import { useQuery } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

/**
 * Fetches the Google consent URL (and issues the CSRF state server-side).
 * Fetched once per login-page load — background refetches are disabled so the
 * URL stays in sync with the single state stored on the session.
 */
export function useGoogleAuthUrl() {
  return useQuery({
    ...orpc.auth.googleAuthUrl.queryOptions(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
